export const PAGINATION = {
  page: 1,
  size: 25,
}
export const LANGARR = [
  { value: '中文', labal: 'zh' },
  { value: '英文', labal: 'en' },
  { value: '韩语', labal: 'ko' },
  { value: '日语', labal: 'ja' },
  { value: '阿拉伯语', labal: 'at' },
  { value: '泰语', labal: 'tr' },
]
export const FINDLANGARR = (labal) => {
  return LANGARR.find((item) => item.labal === labal).value
}
